import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (!environment.production) {
                console.log('HttpInterceptor : ', err);
            } 

            if (err.status === 401) {
                // auto logout if 401 response returned from api
                this.authenticationService.logout();
                if (!(err.error.errorCode === 10)) {
                  location.reload();
                }
            }

            if (err.status === 405) {
                return throwError('Methode non autorisée. Veuillez nous contacter');
            }

            if (err.status === 500) {
                return throwError('Erreur interne. Veuillez nous contacter');
            }


            const error = err.error.message || err.error.error || err.statusText;
            return throwError(error);
        }));
    }
}
